enum TooltipVariants {
  LIGHT = "LIGHT",
  DARK = "DARK",
  WHITE = "WHITE",
  ATTENTION = "ATTENTION",
}

export default TooltipVariants;
